"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var home = exports.home = { "viewBox": "0 0 512 512", "children": [{ "name": "g", "attribs": {}, "children": [{ "name": "polygon", "attribs": { "points": "448,288 256,64 64,288 112,288 112,448 208,448 208,320 304,320 304,448 400,448 400,288 \t" }, "children": [{ "name": "polygon", "attribs": { "points": "448,288 256,64 64,288 112,288 112,448 208,448 208,320 304,320 304,448 400,448 400,288 \t" }, "children": [] }] }] }] };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/ionicons/home.js
// module id = dTG8
// module chunks = 0